import axios from "axios";
import { getRefreshToken, getToken, logout, setRefreshToken, setToken } from "../utils/app.utils";
const token = getToken();
const rToken = getRefreshToken();

const instance = axios.create({
    baseURL: process.env.REACT_APP_API_PATH,  //DEV
    timeout: 100000,
    headers: {
        "Content-Type": "application/json",
        Authorization: token ? `Bearer ${token}` : "",
    },
});

instance.interceptors.request.use(
    function (config) {
        return config;
    },
    function (error) {
        console.log(error);
    }
);


if (token) {
    instance.interceptors.response.use(
        (resp: any) => {
            return resp;
        },
        (validate) => {
            if (validate?.response?.status === 401) {
                const getRefreshToken = async () => {
                    try {
                        const baseUrl = process.env.REACT_APP_API_PATH
                        if (baseUrl) {
                            const res = await axios.get(
                                baseUrl,
                                {
                                    headers: {
                                        Authorization: "Bearer " + rToken,
                                    },
                                }
                            );
                            const data: any = await res.data;
                            setToken(data.result.accessToken);
                            setRefreshToken(data.result.refreshToken);
                            window.location.reload();
                        } else {
                            logout();
                            window.location.href = '/login';
                        }
                    } catch {
                        logout();
                        window.location.href = '/login';
                    }
                };

                getRefreshToken();
            }
            return validate;
        },
    );
}
export default class BaseAPI {
    static api = instance;
}

export function setDefaultURL(url: any) {
    instance.defaults.baseURL = url;
  }
  
